import { useCallback } from "react";
import { Task } from "@common/types/task";
import { useLinkTaskDocuments, useUnlinkTaskDocuments } from "@api/task.api";
import { useToaster } from "@design-system/ToastMessages/useToaster";

export function useTaskDocumentLinkHandlers(task: Task) {
    const { error: toastError } = useToaster();
    const linkDocuments = useLinkTaskDocuments(task);
    const unlinkDocuments = useUnlinkTaskDocuments(task);
    const { mutateAsync: linkMutateAsync } = linkDocuments;
    const { mutateAsync: unlinkMutateAsync } = unlinkDocuments;

    const handleLinkDocument = useCallback(
        async (documentId: number) => {
            try {
                await linkMutateAsync([documentId]);
            } catch (error) {
                toastError("Failed to attach document to task");
                throw error;
            }
        },
        [linkMutateAsync, toastError],
    );

    const handleUnlinkDocuments = useCallback(
        async (documentIds: number[]) => {
            if (documentIds.length === 0) {
                return;
            }
            try {
                await unlinkMutateAsync(documentIds);
            } catch (error) {
                toastError("Failed to remove documents from task");
                throw error;
            }
        },
        [unlinkMutateAsync, toastError],
    );

    return { handleLinkDocument, handleUnlinkDocuments };
}
